//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import userChecks from '~/mixins/userChecks';
export default {
    mixins: [userChecks],
    async fetch() {
        await Promise.all([ 
            this.$store.dispatch('pagesStore/getPage', 'categorieen'),
            this.$store.dispatch('bannerStore/getBanner', 'collection'),
            this.$store.dispatch('resourcesStore/getResources', this.queries.categories)
        ])
    },
    head() {
        return {
            title: this.pages.categorieen && this.pages.categorieen.seo ? this.pages.categorieen.seo.title : 'Genres | Meiden van Holland',
            meta: [
                { hid: 'title', name: 'title', content: this.pages.categorieen && this.pages.categorieen.seo ? this.pages.categorieen.seo.title : 'Genres | Meiden van Holland' },
                { hid: 'og:title', name: 'og:title', content: this.pages.categorieen && this.pages.categorieen.seo ? this.pages.categorieen.seo.title : 'Genres | Meiden van Holland' },
                { hid: 'description', name: 'description', content: this.pages.categorieen && this.pages.categorieen.seo ? this.pages.categorieen.seo.description : 'Sex in allerlei geile smaken zie je op Meiden van Holland. Met onze sexfilm categorieën worden alle geile fantasieën vervuld.'},
                { hid: 'og:description', name: 'og:description', content: this.pages.categorieen && this.pages.categorieen.seo ? this.pages.categorieen.seo.description : 'Sex in allerlei geile smaken zie je op Meiden van Holland. Met onze sexfilm categorieën worden alle geile fantasieën vervuld.' },
                { hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/categorieen' },
                { hid: 'keywords', name: 'keywords', content: this.pages.categorieen && this.pages.categorieen.seo ? this.pages.categorieen.seo.keywords : 'Meiden van Holland Genres'},
            ]
        }
    },
    components: {
        dummyCollection: () => import('~/components/content/dummy/collection.vue'),
        filters: () => import('~/components/filters/filtermodule.vue'),
        categoryItem: () => import('~/components/content/category/category.vue'),
        banner: () => import('~/components/banner.vue'),
        about: () => import('~/components/about_section.vue')
    },
    computed: {
        ...mapState({
            queries: ({ resourcesStore: {queries} }) => queries,
            pages: ({ pagesStore: {pages} }) => pages,
            categories: ({ resourcesStore: {categories} }) => categories,
            loading: ({ resourcesStore: { loading } }) => loading
        }),
    },
}
